import React from "react";

export default function TransparentImageOverBackground() {
  const backgroundStyle = {
    width: "400px",
    height: "400px",
    backgroundImage:
      "url('https://upload.wikimedia.org/wikipedia/commons/c/c6/Tour_eiffel_paris-eiffel_tower.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  };

  const imageStyle = {
    position: "absolute",
    width: "400px",
    height: "400px",
  };

  return (
    <div style={backgroundStyle}>
      <img
        src="http://46.101.82.179/AppOkPrint/static/original/output.png"
        alt="Transparent"
        style={imageStyle}
      />
    </div>
  );
}
